// extracted by mini-css-extract-plugin
module.exports = {"linkWrap":"FullBlockLink-module--linkWrap--3Nr4_","link":"FullBlockLink-module--link--2uFFZ"};